<template>
    <Form :label-width="180">
        <Row>
            <Col span="12">
                <Form-item label="企业名称：">
                    {{info.applicantList[0].subjectName}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="企业证件类型：">
                    {{info.applicantList[0].idTypeDesc}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="企业地址：">
                    {{info.applicantList[0].fullAddress}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="企业证件编码：">
                    {{info.applicantList[0].idNumber}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="详细地址：">
                    {{info.applicantList[0].address}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="联系人姓名：">
                    {{info.applicantList[0].contactName}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="联系人电话：">
                    {{info.applicantList[0].contactPhone}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="联系人邮箱：">
                    {{info.applicantList[0].contactEmail}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="项目编码：">
                    {{info.extraInfo.projectCode}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="项目名称：">
                    {{info.extraInfo.projectName}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="产品名称：">
                    {{info.productName}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="保证金金额：">
                    {{info.insuranceAmount}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="被保人证件类型：">
                    {{info.insuredList[0].idTypeDesc}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="被保企业名称：">
                    {{info.insuredList[0].subjectName}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="被保证件编号：">
                    {{info.insuredList[0].idNumber}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="保单状态：">
                    {{info.insurancePolicyStatusDesc}}
                </Form-item>
            </Col>
            <Col span="12">
                <Form-item label="创建时间：">
                    {{info.createTime}}
                </Form-item>
            </Col>
        </Row>
    </Form>
</template>
<script>
export default {
    props:{
        info:{
            type:"Object",
            default:{}
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/common/insuranceInfo.vue